/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleWithIdDto } from '../../models/article-with-id-dto';

export interface ShopDeleteArticle$Params {
  'x-trace-id'?: string;
  id: string;
      body: ArticleWithIdDto
}

export function shopDeleteArticle(http: HttpClient, rootUrl: string, params: ShopDeleteArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, shopDeleteArticle.PATH, 'delete');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

shopDeleteArticle.PATH = '/api/shop/article/{id}';
